"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderContents = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../../styles");
var Header = styled_components_1.default.header(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", "\n  align-content: flex-end;\n  align-items: center;\n  padding: ", " ", " 0;\n\n  ", "\n\n  h1, p {\n    grid-column: 1 / span 6;\n    text-align: center;\n    width: 100%;\n  }\n\n  h1 {\n    color: ", ";\n    font-family: ", ";\n    ", ";\n    font-weight: 400;\n    ", "\n\n    ", "\n  }\n\n  p {\n    color: ", ";\n    font-family: ", ";\n    ", "\n    font-weight: bold;\n    margin-bottom: 0;\n\n    ", "\n  }\n"], ["\n  ", "\n  ", "\n  align-content: flex-end;\n  align-items: center;\n  padding: ", " ", " 0;\n\n  ", "\n\n  h1, p {\n    grid-column: 1 / span 6;\n    text-align: center;\n    width: 100%;\n  }\n\n  h1 {\n    color: ", ";\n    font-family: ", ";\n    ", ";\n    font-weight: 400;\n    ", "\n\n    ", "\n  }\n\n  p {\n    color: ", ";\n    font-family: ", ";\n    ", "\n    font-weight: bold;\n    margin-bottom: 0;\n\n    ", "\n  }\n"])), (0, styles_1.createGrid)(), (0, styles_1.getMargin60)(), (0, styles_1.getRelative)(144, 'mobile'), (0, styles_1.getRelative)(20, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding:  ", " 0 0;\n  "], ["\n    padding:  ", " 0 0;\n  "])), (0, styles_1.getRelative)(176, 'desktop')), function (_a) {
    var theme = _a.theme;
    return theme.colors.red;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.basier;
}, function (_a) {
    var vienology = _a.vienology;
    return vienology ? (0, styles_1.getP114)() : (0, styles_1.getP200)();
}, (0, styles_1.getMargin30)(), styles_1.mq.greaterThan('tablet')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      grid-column: 3 / span 8;\n    "], ["\n      grid-column: 3 / span 8;\n    "]))), function (_a) {
    var theme = _a.theme;
    return theme.colors.red;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.platform;
}, (0, styles_1.getP93_1)(), styles_1.mq.greaterThan('tablet')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      grid-column: 2 / span 10;\n      padding: 0 ", ";\n    "], ["\n      grid-column: 2 / span 10;\n      padding: 0 ", ";\n    "])), (0, styles_1.getRelative)(60, 'desktop')));
exports.HeaderContents = (0, react_1.memo)(function (_a) {
    var children = _a.children, _b = _a.vienology, vienology = _b === void 0 ? false : _b;
    return ((0, jsx_runtime_1.jsx)(Header, __assign({ vienology: vienology }, { children: children })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
